module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/ppptenlords005#toc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Oh! glory of youth! consolation of age!")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Sublimest of ecstasies under the sun;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Though the veteran may linger too long on the stage,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Yet he’ll drink a last toast to a fox-hunting run.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("And oh! young descendants of ancient top-sawyers!")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("By your lives to the world their example enforce;")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Whether landlords, or parsons, or statesmen, or lawyers,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Ride straight as they rode it from Ranksboro’ Gorse.")]), _vm._v(" "), _c('p', {
    staticClass: "epl"
  }, [_vm._v("From ‘The Dream of the Old Meltonian’")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("W. Bromley Davenport")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639bb2de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ppp-tenlords006.vue
// module id = 72
// module chunks = 0